import api from "Common/Client/Interceptor";

const getAuthHeaders = () => ({
  accept: "*/*",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchInvites = async ({ pageNumber = 1, pageSize = 10, orderByLatest = false } = {}) => {
  try {
    const response = await api.get(
      `InviteUser/Get-Manager-Invites?pageNumber=${pageNumber}&pageSize=${pageSize}&orderByLatest=${orderByLatest}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resendInvite = async (inviteId) => {
  try {
    const response = await api.get(`InviteUser/Resend-Invite?inviteId=${inviteId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendInvite = async (inviteData) => {
  try {
    const response = await api.post(`InviteUser/SendInviteByManagerToEmployee`, inviteData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
